<template>
  <div class="wg-row" style="height:calc(100vh - 60px);">
    <!-- Sub menu con scelta categorie -->
    <world-sub-menu 
        :selected="pageId"
        :list="list"
        @changePage="changePage">
      <template v-slot:content>
        <!-- License -->
        <license v-if="pageId === 'app'" :licenseRef="license" :timezone="timezone"></license>
        <!-- User settings -->
        <user v-if="pageId === 'user'"></user>
        <!-- Tables editor -->
        <tables v-if="pageId === 'tables'"></tables>
        <!-- Admins -->
        <admins v-if="pageId === 'admins'"></admins>
        <!-- Cards -->
        <cards v-if="pageId === 'cards'" :permission="permission" :timezone="timezone"></cards>
        <!-- Database -->
        <database v-if="pageId === 'db'"  :timezone="timezone"></database>
        <!-- Reports -->
        <reports v-if="pageId === 'reports'"  :timezone="timezone"></reports>
        <!-- Logs -->
        <logs v-if="pageId === 'logs'" :timezone="timezone"></logs>
        <!-- Printers -->
        <printers v-if="pageId === 'printers'" :timezone="timezone"></printers>
        <!-- License QR code -->
        <links v-if="pageId === 'links'" :license="license" :timezone="timezone"></links>
        <!-- Devs -->
        <div v-if="pageId === 'devs'" class="wg-row">
          <div class="com-anm22-page-title" style="font-size:24px;">
            {{ $anm22.strLang(lang, 'Developers', 'Sviluppatori') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <button class="" @click="goToTest">
            <div >
              {{ $anm22.strLang(lang, 'Open test version', 'Apri versione di test') }}
            </div>
          </button>
          <div class="vertical-height-div" style="height:10px;"></div>
          <button class="" @click="goToConfig">
            <div>
              {{ $anm22.strLang(lang, 'Open License config', 'Apri configurazione licenza') }}
            </div>
          </button>
        </div>
        <!-- Version -->
        <div v-if="pageId === 'version'" class="wg-row" style="justify-content:center;">
          <div class="com-anm22-page-title" style="font-size:24px;">
            {{ $anm22.strLang(lang, 'Software version', 'Versione software') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-xxl">
            YourFood
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-l">
            {{ version }} 
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
      </template>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import License from '../components/settings/License.vue';
import User from '../components/settings/User.vue';
import Tables from '../components/settings/Tables.vue';
import Admins from '../components/settings/Admins.vue';
import Cards from '../components/settings/Cards.vue';
import Database from '../components/settings/Database.vue';
import Reports from '../components/settings/Reports.vue';
import Logs from '../components/settings/Logs.vue';
import Printers from '../components/settings/Printers.vue';
import Links from '../components/settings/Links.vue';
import WorldSubMenu from '../../../../world/spa/components/WorldSubMenu.vue';

export default {
  data() {
    return {
      loading: false,
      pageId: "",
      // Version
      version: process.env.VERSION
    }
  },
  components: {
    WorldSubMenu,
    License,
    User,
    Tables,
    Admins,
    Cards,
    Database,
    Reports,
    Logs,
    Printers,
    Links,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment ? this.employment.permission : 6;
    },
    accessControl() {
      return this.$store.getters["foodAcs/get"](
        this.license.id + "-" + this.permission
      );
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    list() {
      const list = [];
      // Generali
      if(this.employment) {
        if(this.permission < 4) {
          list.push(
            {
              id: "app",
              img: this.$anm22.icons.getWorldIcon("settingsSet"),
              label: this.$anm22.strLang(this.lang, 'App settings', 'Impostazioni applicazione'),
              component: 'License'
            }
          );
        }
        if(this.license.config.modules.fastCash.enabled) {
          list.push(
            {
              id: "user",
              img: this.$anm22.icons.getWorldIcon("settingsSet"),
              label: this.$anm22.strLang(this.lang, 'User settings', 'Impostazioni utente'),
              component: 'User'
            }
          );
          if(this.license.config.modules.tables.enabled && this.permission < 5) {
            list.push(
              {
                id: "tables",
                img: this.$anm22.icons.getWorldIcon("settingsPhoto"),
                label: this.$anm22.strLang(this.lang, 'Edit tables map', 'Modifica mappa tavoli'),
                component: 'Tables'
              }
            );
          }
          if(!(this.permission > 2 && (this.license.work == 1 || this.license.work == 2 || this.license.work == 289))) {
            list.push(
              {
                id: "admins",
                img: this.$anm22.icons.getWorldIcon("settingsUser"),
                label: this.$anm22.strLang(this.lang, 'Manage admins', 'Gestione amministratori'),
                component: 'Admins'
              }
            );
          }
          if(this.accessControl.card) {
            list.push(
              {
                id: "cards",
                img: this.$anm22.icons.getWorldIcon("settingsUser"),
                label: this.$anm22.strLang(this.lang, 'Cards management', 'Gestione tessere'),
                component: 'Cards'
              }
            );
          }
          if(this.permission < 4) {
            list.push(
              {
                id: "db",
                img: this.$anm22.icons.getWorldIcon("settingsSet"),
                label: 'Database'
              }
            );
            list.push(
              {
                id: "reports",
                img: this.$anm22.icons.getWorldIcon("settingsSet"),
                label: this.$anm22.strLang(this.lang, 'Daily reports', 'Report giornalieri'),
                component: 'Reports'
              }
            );
            list.push(
              {
                id: "logs",
                img: this.$anm22.icons.getWorldIcon("settingsSet"),
                label: this.$anm22.strLang(this.lang, 'App logs', 'Log applicazione'),
                component: 'Logs'
              }
            );
            list.push(
              {
                id: "printers",
                img: this.$anm22.icons.getWorldIcon("settingsPrinter"),
                label: this.$anm22.strLang(this.lang, 'Printers', 'Stampanti'),
                component: 'Printers'
              }
            );
          }
        }
        list.push(
          {
            id: "links",
            img: this.$anm22.icons.getWorldIcon("settingsVer"),
            label: this.$anm22.strLang(this.lang, 'License links', 'Link licenza')
          }
        );
        if(this.permission < 2) {
          list.push(
            {
              id: "devs",
              img: this.$anm22.icons.getWorldIcon("settingsSet"),
              label: this.$anm22.strLang(this.lang, 'Developer options', 'Opzioni sviluppatore')
            }
          );
        }
      }
      list.push(
        {
          id: "version",
          img: this.$anm22.icons.getWorldIcon("settingsVer"),
          label: this.$anm22.strLang(this.lang, 'Version', 'Versione')
        }
      );
      return list;
    }
  },
  methods: {
    goToTest() {
      window.location.href = "https://www.anm22.it/app/food-test-v/";
    },
    goToConfig() {
      window.location.href = "https://www.anm22.it/app/work/yourFoodLicenses";
    },
    changePage(elem) {
      if(typeof elem == 'string') {
        elem = this.list.find(l => l.id === elem);
      }
      this.pageId = elem.id;
    },
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, 'Settings', 'Impostazioni');
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, 'Settings', 'Impostazioni')
    );
    this.loading = true;
    this.$http
      .get('settings')
      .then(response => {
        Promise.all([
          this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: [response.data.license]
          }),
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: [response.data.employment]
          }),
          this.$store.dispatch("foodAcs/update", {
            vlf: this.$vlf("foodAcs"),
            objs: [response.data.accessControl]
          }),
        ])
        .then(() => {
          this.pageId = this.list[0].id;
          this.loading = false;
          this.$Progress.finish();
        })
      })
      .catch(error => console.log(error));
  }
}
</script>

<style lang="scss" scoped>
.qrcode {
  display: block;
  margin: 0 auto;
  padding: 10px;
  width: 150px;
  height: 150px;
}
</style>
